import { render } from "./referralCode.vue?vue&type=template&id=80e02442&scoped=true"
import script from "./referralCode.vue?vue&type=script&lang=js"
export * from "./referralCode.vue?vue&type=script&lang=js"

import "./referralCode.vue?vue&type=style&index=0&id=80e02442&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e02442"]])

export default __exports__